 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVER from '@/components/OEBPS/cover'
 import OEBPSEBB from '@/components/OEBPS/ebb'
 import OEBPSARCHIVE from '@/components/OEBPS/archive'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSDEDICATION from '@/components/OEBPS/Dedication'
 import OEBPSCONTENTS from '@/components/OEBPS/contents'
 import OEBPSILLUSTRATIONS from '@/components/OEBPS/illustrations'
 import OEBPSFM01 from '@/components/OEBPS/fm01'
 import OEBPSPROLOGUE from '@/components/OEBPS/prologue'
 import OEBPSPART1 from '@/components/OEBPS/part1'
 import OEBPSCH01 from '@/components/OEBPS/ch01'
 import OEBPSCH02 from '@/components/OEBPS/ch02'
 import OEBPSCH03 from '@/components/OEBPS/ch03'
 import OEBPSCH04 from '@/components/OEBPS/ch04'
 import OEBPSCH05 from '@/components/OEBPS/ch05'
 import OEBPSCH06 from '@/components/OEBPS/ch06'
 import OEBPSCH07 from '@/components/OEBPS/ch07'
 import OEBPSCH08 from '@/components/OEBPS/ch08'
 import OEBPSCH09 from '@/components/OEBPS/ch09'
 import OEBPSCH10 from '@/components/OEBPS/ch10'
 import OEBPSCH11 from '@/components/OEBPS/ch11'
 import OEBPSCH12 from '@/components/OEBPS/ch12'
 import OEBPSCH13 from '@/components/OEBPS/ch13'
 import OEBPSCH14 from '@/components/OEBPS/ch14'
 import OEBPSCH15 from '@/components/OEBPS/ch15'
 import OEBPSCH16 from '@/components/OEBPS/ch16'
 import OEBPSCH17 from '@/components/OEBPS/ch17'
 import OEBPSPART2 from '@/components/OEBPS/part2'
 import OEBPSCH18 from '@/components/OEBPS/ch18'
 import OEBPSCH19 from '@/components/OEBPS/ch19'
 import OEBPSCH20 from '@/components/OEBPS/ch20'
 import OEBPSCH21 from '@/components/OEBPS/ch21'
 import OEBPSCH22 from '@/components/OEBPS/ch22'
 import OEBPSCH23 from '@/components/OEBPS/ch23'
 import OEBPSCH24 from '@/components/OEBPS/ch24'
 import OEBPSCH25 from '@/components/OEBPS/ch25'
 import OEBPSCH26 from '@/components/OEBPS/ch26'
 import OEBPSCH27 from '@/components/OEBPS/ch27'
 import OEBPSCH28 from '@/components/OEBPS/ch28'
 import OEBPSCH29 from '@/components/OEBPS/ch29'
 import OEBPSCH30 from '@/components/OEBPS/ch30'
 import OEBPSCH31 from '@/components/OEBPS/ch31'
 import OEBPSCH32 from '@/components/OEBPS/ch32'
 import OEBPSCH33 from '@/components/OEBPS/ch33'
 import OEBPSCH34 from '@/components/OEBPS/ch34'
 import OEBPSCH35 from '@/components/OEBPS/ch35'
 import OEBPSPART3 from '@/components/OEBPS/part3'
 import OEBPSCH36 from '@/components/OEBPS/ch36'
 import OEBPSCH37 from '@/components/OEBPS/ch37'
 import OEBPSCH38 from '@/components/OEBPS/ch38'
 import OEBPSCH39 from '@/components/OEBPS/ch39'
 import OEBPSCH40 from '@/components/OEBPS/ch40'
 import OEBPSCH41 from '@/components/OEBPS/ch41'
 import OEBPSCH42 from '@/components/OEBPS/ch42'
 import OEBPSEPILOGUE from '@/components/OEBPS/epilogue'
 import OEBPSAPPENDICES from '@/components/OEBPS/appendices'
 import OEBPSBIBLIOGRAPHY from '@/components/OEBPS/bibliography'
 import OEBPSCOPYRIGHT from '@/components/OEBPS/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cover",
 			"name" : "OEBPS/cover",
 			"component" : OEBPSCOVER
 		},
 		{
 			"path" : "/OEBPS/ebb",
 			"name" : "OEBPS/ebb",
 			"component" : OEBPSEBB
 		},
 		{
 			"path" : "/OEBPS/archive",
 			"name" : "OEBPS/archive",
 			"component" : OEBPSARCHIVE
 		},
 		{
 			"path" : "/OEBPS/tp",
 			"name" : "OEBPS/tp",
 			"component" : OEBPSTP
 		},
 		{
 			"path" : "/OEBPS/Dedication",
 			"name" : "OEBPS/Dedication",
 			"component" : OEBPSDEDICATION
 		},
 		{
 			"path" : "/OEBPS/contents",
 			"name" : "OEBPS/contents",
 			"component" : OEBPSCONTENTS
 		},
 		{
 			"path" : "/OEBPS/illustrations",
 			"name" : "OEBPS/illustrations",
 			"component" : OEBPSILLUSTRATIONS
 		},
 		{
 			"path" : "/OEBPS/fm01",
 			"name" : "OEBPS/fm01",
 			"component" : OEBPSFM01
 		},
 		{
 			"path" : "/OEBPS/prologue",
 			"name" : "OEBPS/prologue",
 			"component" : OEBPSPROLOGUE
 		},
 		{
 			"path" : "/OEBPS/part1",
 			"name" : "OEBPS/part1",
 			"component" : OEBPSPART1
 		},
 		{
 			"path" : "/OEBPS/ch01",
 			"name" : "OEBPS/ch01",
 			"component" : OEBPSCH01
 		},
 		{
 			"path" : "/OEBPS/ch02",
 			"name" : "OEBPS/ch02",
 			"component" : OEBPSCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js